import api from 'src/Utils/api';
export var cancelReservation = function (id) { return api.delete("/bookings/" + id); };
